import styled from "@emotion/styled";
import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SchoolIcon from "@mui/icons-material/School";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Modal, Slide } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Lottie from "lottie-react";
import tickAnimation from "../../assets/tick.json";

const Index = () => {
    const navigate = useNavigate();
    const [showForm, setShowForm] = React.useState(false);
    const [showSuccess, setShowSuccess] = React.useState(false);

    const onFormSubmit = async (data) => {
        // await axios.post("https://api.loylalaw.com/zoom-meeting", data);
        setShowSuccess(true);
        setTimeout(() => {
            setShowSuccess(false);
        }, 12000);
    };

    return (
        <Wrapper style={{ minHeight: "100vh" }}>
            <Header>
                <img
                    src="/loyla-logo.png"
                    alt="Loyla Logo"
                    style={{ width: "210px", transform: "translateX(-10px)" }}
                />
                <Heading>
                    Welcome to Loyola <br /> Law School!
                </Heading>
                <SubHeading>Have a question?</SubHeading>
            </Header>
            {!showForm ? (
                <Features>
                    <FeatureCard
                        img={"/loyla-chat.png"}
                        heading={"Chat with us"}
                        onClick={() => navigate("/widget-lls")}
                        paragraph={
                            "Speak to a current student, alum, or faculty advisor on WhatsApp. "
                        }
                    />
                    <FeatureCard
                        img={"/loyla-zoomcall.png"}
                        heading={"Schedule a Zoom call"}
                        onClick={() => setShowForm(true)}
                        paragraph={
                            "Join a Zoom meeting with our admissions team. "
                        }
                    />
                    <PoweredBy>
                        Powered By
                        <CITLink
                            href="https://collegeit.org"
                            target="_blank"
                            rel="no-referer"
                        >
                            <SchoolIcon
                                style={{ fontSize: "20px", marginRight: "3px" }}
                            />
                            CollegeIt
                        </CITLink>
                    </PoweredBy>
                </Features>
            ) : (
                <Wrapper>
                    <ZoomForm
                        goBack={() => setShowForm(false)}
                        onFormSubmit={onFormSubmit}
                    />
                </Wrapper>
            )}
            <Modal
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                closeAfterTransition
            >
                <Slide direction="up" in={showSuccess}>
                    <Box
                        style={{
                            height: "100%",
                            width: "100%",
                            background: "white",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "start",
                            paddingTop: "120px",
                            position: "relative",
                        }}
                    >
                        <SuccessMessage close={() => setShowSuccess(false)} />
                    </Box>
                </Slide>
            </Modal>
        </Wrapper>
    );
};

const SuccessMessage = ({ close }) => {
    return (
        <>
            <IconButton
                onClick={close}
                style={{ position: "absolute", top: "0", left: "0" }}
            >
                <ArrowBackIcon />
            </IconButton>
            <h1
                style={{
                    width: "80%",
                    fontFamily: "Outfit",
                    fontSize: "23px",
                    textAlign: "center",
                    paddingBottom: "20px",
                }}
            >
                Your meeting request has been submitted successfully!
            </h1>
            <Lottie
                {...{
                    loop: false,
                    autoplay: true,
                    animationData: tickAnimation,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }}
                height={100}
                width={100}
            />
            <span
                style={{
                    paddingTop: "28px",
                    fontFamily: "Outfit",
                    textAlign: "center",
                    color: "gray",
                    fontSize: "20px",
                    width: "80%",
                }}
            >
                We will reach out to you shortly.
            </span>
        </>
    );
};

const FeatureCard = ({ img, heading, paragraph, onClick = () => {} }) => {
    return (
        <FeatureCardWrapper onClick={onClick} dontHover>
            <FeatureCardImage src={img} alt="Chat Icon" />
            <FeatureCardBody>
                <FeatureCardHeading>{heading}</FeatureCardHeading>
                <FeatureCardP>{paragraph}</FeatureCardP>
            </FeatureCardBody>
            <FeatureCardNextButton>
                <ArrowForwardIcon />
            </FeatureCardNextButton>
        </FeatureCardWrapper>
    );
};

const ZoomForm = ({ goBack, onFormSubmit }) => {
    const [email, setEmail] = React.useState("");
    const [country, setCountry] = React.useState("");

    const handleNameChange = (e) => {
        setEmail(e.target.value);
    };

    const handleCountryChange = (e) => {
        setCountry(e.target.value);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        await onFormSubmit({ email, country });
        console.log("Submitted");
    };

    return (
        <FeatureCardWrapper
            style={{
                marginTop: "30px",
                width: "90%",
                boxSizing: "border-box",
                flexDirection: "column",
                scale: "1",
                padding: "18px 26px",
            }}
        >
            <FeatureCardHeading style={{ fontSize: "20px" }}>
                Schedule a meeting
            </FeatureCardHeading>
            <FeatureCardP
                style={{
                    fontSize: "14px",
                    marginBottom: "12px",
                    lineHeight: "1.2",
                }}
            >
                Please provide the following details. Our team will contact you
                shortly.{" "}
            </FeatureCardP>
            <form onSubmit={onSubmit}>
                <MeetInput
                    value={email}
                    onChange={handleNameChange}
                    placeholder="Email address*"
                    type="email"
                    style={{ marginTop: "8px" }}
                    required
                />
                <MeetInput
                    value={country}
                    onChange={handleCountryChange}
                    placeholder="Country*"
                    type="text"
                    style={{ marginTop: "14px", marginBottom: "14px" }}
                    required
                />
                <div style={{ display: "flex", gap: "12px" }}>
                    <Button
                        style={{
                            textTransform: "none",
                            padding: "1px 9px",
                            fontFamily: "Outfit",
                            color: "gray",
                            borderColor: "gray",
                            fontWeight: "400",
                        }}
                        onClick={goBack}
                        variant="outlined"
                    >
                        Go Back
                    </Button>
                    <Button
                        style={{
                            textTransform: "none",
                            padding: "1px 9px",
                            fontFamily: "Outfit",
                            backgroundColor: "#2E8EFF",
                            fontWeight: "400",
                        }}
                        variant="contained"
                        type="submit"
                    >
                        Request Meeting
                    </Button>
                </div>
            </form>
        </FeatureCardWrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
`;

const Header = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: #ab0c2f;
    width: 100%;
    padding: 12px 24px;
`;

const Heading = styled.h2`
    color: #fff;
    font-family: Outfit;
    font-size: 26px;
    margin: 0;
    margin-top: 12px;
    line-height: 1.1;
`;

const SubHeading = styled.h3`
    color: #fff;
    font-family: Outfit;
    font-size: 19px;
    font-weight: 400;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 6px;
`;

const Features = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 16px;
    gap: 20px;
`;

const FeatureCardWrapper = styled.div`
    background-color: #fff;
    width: 87%;
    padding: 14px 18px;
    display: flex;
    box-shadow: 0 0 12px #dedede;
    border-radius: 16px;
    transition: 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;

    ${({ dontHover }) =>
        dontHover
            ? `&:hover {
        box-shadow: 0 0 12px #949494;
        scale: 1.02;
    }`
            : ""}

    &:active {
        scale: 1;
    }
    & svg {
        color: #aaaaaa;
    }

    &:hover svg {
        color: black;
        right: 0;
    }
`;
const FeatureCardImage = styled.img`
    height: 60px;
    width: 60px;
`;
const FeatureCardBody = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 18px;
`;

const FeatureCardHeading = styled.h3`
    font-family: Outfit;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
`;

const FeatureCardP = styled.p`
    font-family: Outfit;
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    margin-top: 4px;
    color: #000000b7;
`;

const FeatureCardNextButton = styled.div`
    position: absolute;
    right: 6px;
    color: #ddd;
    top: 2px;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.2s ease-in-out;
`;

const PoweredBy = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    font-family: Outfit;
    font-size: 14px;
    font-weight: 500;
    color: #00000077;
`;

const CITLink = styled.a`
    color: #00000077;
    margin-left: 4px;
    text-decoration: none;
    transition: 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-family: Outfit;

    &:hover {
        text-decoration: underline;
    }
`;

// const BackButton = styled(Button)`
//     position: absolute;
//     border-radius: 1000px;
//     top: 12px;
//     left: 12px;
//     background-color: #fff;
//     color: #ab0c2f;
//     box-shadow: 0 0 12px #dedede;
//     transition: 0.2s ease-in-out;
//     text-transform: none;
//     box-shadow: 0 0 4px #d1d1d1;
//     padding: 2px 4px;

//     &:hover {
//         box-shadow: 0 0 12px #d6d6d6;
//         background-color: #fff;
//         scale: 1.02;
//     }
//     &:active {
//         scale: 1;
//     }
// `;

const MeetInput = styled.input`
    width: 100%;
    font-family: Outfit;
    box-sizing: border-box;
    padding: 6px 12px;
    background-color: #ececec;
    font-size: 14px;
    outline: none;
    border: none;
    border-radius: 6px;
`;

export default Index;
